@use '@lib/assets/styles/main.scss' as *;

.actions {
  text-align: center;
}
